import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => {
  return {
    path: "student",
    component: withAsyncRouteLoading(() => {
      return Promise.all([
        import(/* webpackChunkName: "student" */ "./components"),
        import(
          /* webpackChunkName: "student" */ "./modules/RosterStudentsToNextAcademicYearModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        const reducer = module.default;
        const key = module.NAME;
        injectReducer(store, {
          key,
          reducer,
        });
        return component;
      });
      //.catch(err => {
      // throw err;
      // });
    }),
  };
};
